var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(!_vm.accountTemplatesLoading)?_c('v-col',[_c('templates-template-list',{attrs:{"title":_vm.templateListTitle,"templates":_vm.accountTemplates,"new-template-defaults":_vm.newTemplateDefaults}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }